
<template>
  <div class="head" :style="info.bg">
    <div class="go-back" @click="goBack"><img src="../../assets/images/arrow_l.png" alt=""></div>
    <van-search v-model="search" shape="round" @search="onSearch()" :placeholder="info.placeholder?info.placeholder:'请输入搜索关键词'" v-if="info.type=='search'"/>
    <div class="title" v-else>{{info.name}}</div>
  </div>
</template>

<script type="text/babel">
// 组件
export default {
  name: 'Head',
  props:{
      info:{
          type: Object,
          default: () => {
              return {}
          }
      }
  },
  data() {
    return {
      search: ''
    };
  },
  created() {},
 mounted() {
 },
  methods: {
      goBack() {
        this.$router.go(-1)
      },
      onSearch() {
        this.$emit('outSearch',{search:this.search})
      }
  }
};
</script>

<style scoped lang="less">
  .head{
      display: flex;
      align-items: center;
      height: 40px;
      padding: 13.5px 15px;
      background-color: #F1F1F1;
      /deep/.van-search{
        flex: 1;
        background: none;
      }
      .go-back{
          img{
              height: 20px;
              width: 10px;
          }
      }
      .title{
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex: 1;
      }
  }

</style>
